<template>
  <el-pagination
    v-show="!loading && pageTotal"
    @current-change="changePage"
    background
    :current-page.sync="pageNum.num"
    :page-size="pageSize"
    layout="total, prev, pager, next, jumper"
    :total="pageTotal">
  </el-pagination>
</template>

<script>
export default {
  props: {
    pageNum: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pageSize: {
      type: Number,
      default: function () {
        return 20
      }
    },
    pageTotal: {
      type: Number,
      default: function () {
        return 0
      }
    },
    loading: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  methods: {
    changePage(val) {
      const self = this
      self.$emit('change', val)
      self.$store.commit({
        type: 'setQueryTable',
        data: {
          pageNum: val
        }
      })
    }
  }
}
</script>

<style>

</style>
